import React from 'react';
import {
  FiHeart,
  FiStar,
  FiAward,
  FiCoffee,
  FiMapPin,
  FiTruck,
  FiKey,
  FiVideo,
  FiDollarSign,
  FiCamera,
  FiZap,
  FiUsers,
  FiArrowRight,
} from 'react-icons/fi';
import { useReservation } from '../contexts/ReservationContext';
import './Services.css';

const Services = () => {
  const { open } = useReservation();
  const services = [
    {
      icon: FiHeart,
      title: 'Mariages',
      description:
        "Rendez votre jour J encore plus mémorable. Nos limousines d'exception ajoutent une touche de luxe et d'élégance au plus beau jour de votre vie.",
      features: ['Décoration florale', 'Champagne offert', 'Photoshoot privé', 'Itinéraire sur mesure'],
      image: '/images/gallery/maries-hummer-tour-eiffel-paris-mariage.webp',
      alt: "Mariés devant limousine Hummer blanche et Tour Eiffel à Paris - VIP Limousine mariage",
    },
    {
      icon: FiStar,
      title: 'Transport VIP',
      description:
        "Vous êtes une personnalité VIP ou vous souhaitez offrir le meilleur service à un invité prestigieux ? Confort, fiabilité, sécurité et confidentialité garantis.",
      features: ['Chauffeur dédié', 'Discrétion totale', 'Accueil personnalisé', 'Véhicule premium'],
      image: '/images/gallery/rolls-royce-phantom-place-vendome-paris.webp',
      alt: "Rolls Royce Phantom blanche service VIP Place Vendôme Paris devant Dior",
    },
    {
      icon: FiAward,
      title: 'Bal de promo',
      description:
        "Célébrez votre bal des finissants comme il se doit. Arrivez en grande classe à bord de nos limousines et soyez la star de la soirée avec vos amis.",
      features: ['Ambiance sonore', 'Éclairage d\'ambiance', 'Boissons non-alcoolisées', 'Photos souvenirs'],
      image: '/images/gallery/limousine-chrysler-tapis-rouge-coucher-soleil.webp',
      alt: "Limousine Chrysler 300 blanche avec tapis rouge pour bal de promo en Île-de-France",
    },
    {
      icon: FiCoffee,
      title: 'Soirée Restaurant',
      description:
        "Sortie chic au restaurant, dîner corporatif, soirée romantique ou entre amis : déplacez-vous dans le confort et la classe d'une limousine de luxe.",
      features: ['Réservation à l\'heure', 'Attente incluse', 'Discrétion assurée', 'Itinéraire flexible'],
      image: '/images/gallery/limousine-chrysler-place-vendome-paris.webp',
      alt: "Limousine Chrysler 300 blanche Place Vendôme Paris pour soirée chic",
    },
    {
      icon: FiMapPin,
      title: 'Navette Aéroport',
      description:
        "Les transferts aéroport peuvent être stressants. Nous nous occupons de tout pour un trajet confortable, luxueux et sans souci, vers ou depuis tous les aéroports parisiens.",
      features: ['Suivi des vols', 'Accueil avec panneau', 'Assistance bagages', 'Tarif forfaitaire'],
      image:
        'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=900&q=80',
      alt: 'Avion sur le tarmac au coucher du soleil',
    },
    {
      icon: FiTruck,
      title: 'Transport Privé',
      description:
        "Nos véhicules et chauffeurs professionnels sont disponibles pour tout simple transport d'un point A à un point B. Détendez-vous, nous rendons le trajet agréable et sécuritaire.",
      features: ['Point à point', 'Longue distance', 'Service 24/7', 'Tarifs compétitifs'],
      image:
        'https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=900&q=80',
      alt: 'Véhicule de transport sur autoroute',
    },
    {
      icon: FiKey,
      title: 'Location Limousine',
      description:
        "Vous recherchez un service de limousine avec chauffeur ? Profitez du luxe et du confort d'un véhicule haut de gamme avec notre service professionnel personnalisé.",
      features: ['Chauffeur expérimenté', 'Véhicules récents', 'Forfait horaire', 'Sur mesure'],
      image: '/images/gallery/hummer-limousine-place-vendome-paris.webp',
      alt: "Location limousine Hummer blanche stretch Place Vendôme Paris avec chauffeur",
    },
    {
      icon: FiVideo,
      title: 'Vidéoclip',
      description:
        "Pour produire un vidéoclip avec style, élégance et classe, nos limousines de luxe sont le choix parfait. Impressionnez dans vos productions musicales.",
      features: ['Décor prestigieux', 'Plusieurs modèles', 'Location à la demi-journée', 'Accompagnement'],
      image: '/images/gallery/interieur-rolls-royce-phantom-ciel-etoile-paris.webp',
      alt: "Intérieur de Rolls Royce Phantom blanche avec ciel étoilé pour tournage de vidéoclip à Paris",
    },
    {
      icon: FiDollarSign,
      title: 'Soirée Casino',
      description:
        "Les casinos sont synonymes de style, d'élégance et de divertissement. Faites une entrée éclatante à bord d'une de nos limousines et épatez la galerie.",
      features: ['Arrivée spectaculaire', 'Boissons incluses', 'Service discret', 'Retour inclus'],
      image:
        'https://images.unsplash.com/photo-1596838132731-3301c3fd4317?auto=format&fit=crop&w=900&q=80',
      alt: 'Cartes à jouer dorées sur fond noir',
    },
    {
      icon: FiCamera,
      title: 'Shooting Photo',
      description:
        "Nos véhicules sont disponibles pour vos séances photos. Profitez de l'élégance et de la prestance unique qu'apportent nos voitures à vos images.",
      features: ['Choix de véhicules', 'Location studio', 'Décors variés', 'Assistance sur place'],
      image: '/images/gallery/hummer-limousine-shooting-photo-modeles.webp',
      alt: "Limousine Hummer blanche stretch avec mannequins en shooting photo professionnel",
    },
    {
      icon: FiZap,
      title: 'Véhicules de Luxe',
      description:
        "Mercedes, Bentley, Porsche, Audi, Rolls Royce... Notre large gamme de véhicules de luxe et exotiques vous offre l'embarras du choix pour toutes les occasions.",
      features: ['Flotte premium', 'Marques prestigieuses', 'Entretien irréprochable', 'Sur réservation'],
      image: '/images/gallery/rolls-royce-phantom-place-vendome-noel.webp',
      alt: "Rolls Royce Phantom blanche véhicule de luxe Place Vendôme Paris décorations de Noël",
    },
    {
      icon: FiUsers,
      title: 'Sortie entre amis',
      description:
        "Pour passer d'excellents moments entre ami(e)s avec un service complet et de qualité. Sortie au club, soirée élégante, anniversaire... célébrez en style.",
      features: ['Jusqu\'à 10 personnes', 'Ambiance festive', 'Plusieurs arrêts', 'Service VIP'],
      image: '/images/gallery/interieur-limousine-anniversaire-paris.webp',
      alt: "Intérieur de limousine décoré pour anniversaire avec ambiance festive à Paris",
    },
  ];

  return (
    <section className="services section-padding">
      <div className="container">
        <div className="section-header text-center">
          <span className="section-badge">Nos Services</span>
          <h2 className="section-title">
            Excellence & Prestations
            <span className="title-accent">Sur Mesure</span>
          </h2>
          <p className="section-description">
            Découvrez notre gamme complète de services de transport de luxe,
            conçus pour répondre à tous vos besoins avec élégance et professionnalisme.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <article
                key={index}
                className="service-card"
                style={{ animationDelay: `${Math.min(index, 6) * 0.08}s` }}
              >
                <div className="service-image-wrapper">
                  <img
                    src={service.image}
                    alt={service.alt}
                    className="service-image"
                    loading="lazy"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                  <div className="service-image-gradient"></div>
                  <div className="service-icon-badge">
                    <IconComponent size={22} />
                  </div>
                  <h3 className="service-title-overlay">{service.title}</h3>
                </div>

                <div className="service-card-body">
                  <p className="service-description">{service.description}</p>

                  <ul className="service-features">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="service-feature">
                        <span className="feature-bullet"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <button
                    type="button"
                    className="service-btn"
                    onClick={() => open({ evenement: service.title })}
                  >
                    <span>Réserver</span>
                    <FiArrowRight className="service-btn-arrow" />
                  </button>
                </div>
              </article>
            );
          })}
        </div>

        <div className="services-cta">
          <div className="cta-content">
            <h3>Besoin d'un service personnalisé ?</h3>
            <p>
              Nos experts sont à votre disposition pour créer une solution sur mesure
              adaptée à vos besoins spécifiques.
            </p>
            <button type="button" className="btn btn-primary" onClick={() => open()}>
              Contactez-nous
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
